import React, { FC } from 'react';
import closeIcon from './close-icon.svg';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
	btnCloseWrapper: {
		position: 'absolute',
		top: 4,
		right: 4,
	},
	btnClose: {
		margin: '2px',
		height: 30,
		width: 30,
		cursor: 'pointer',
	},
}));

const ButtonClose: FC<{ onClick: () => void }> = ({ onClick }) => {
	const classes = useStyles();
	return (
		<div className={classes.btnCloseWrapper}>
			<img
				className={classes.btnClose}
				src={closeIcon}
				alt="close"
				onClick={onClick}
				role="button"
			/>
			<div />
		</div>
	);
};

export default ButtonClose;
